/** Only existing native chat routes belong in the dock. Business pages stay in the workspace router. */
export function isChatDockPath(path: string): boolean {
  const pathname = path.split(/[?#]/, 1)[0]
  return pathname === "/new-session" || /^\/server\/[^/]+\/session\/[^/]+\/?$/.test(pathname)
}

export function localWorkspacePath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//") && !path.includes("\\")
}
